import { SERVER_URL } from "../../../constants";

// generic auth JSON fetch (GET/POST etc.)
export async function fetchJsonAuth(url, token, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  if (!res.ok) throw new Error(`${url} -> ${res.status}`);
  return res.json();
}

// batch students (preserves requested order)
export async function fetchStudentsByIds(ids, token) {
  if (!ids?.length) return [];

  const unique = Array.from(new Set(ids));

  const students = await fetchJsonAuth(`${SERVER_URL}api/students/batch`, token, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ ids: unique }),
  });

  const byId = new Map(students.map((s) => [s.id, s]));
  return ids.map((id) => byId.get(id)).filter(Boolean);
}
